export const ftlValuesGlobalName = "kcContext";
